var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"home fill-height",attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center","no-gutters":""}},[_c('v-col',{attrs:{"cols":"12","sm":"8","md":"4","xl":"2"}},[_c('div',{staticClass:"py-12"},[_c('v-img',{staticClass:"w-100",attrs:{"src":require("@/assets/logo.svg")}})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }